import { twMerge } from "tailwind-merge";
import { FaCircleExclamation } from "react-icons/fa6";
export type ErrorMessageProps = {
  className?: string;
  message: string;
  withIcon?: boolean;
};
const ErrorMessage = ({
  className,
  message,
  withIcon = true
}: ErrorMessageProps) => {
  return <div className={twMerge("flex w-full items-center gap-4 rounded bg-red-500 px-4 py-2 text-white", className)} data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.tsx">
      {withIcon && <div>
          <FaCircleExclamation />
        </div>}
      <span className="font-medium">{message}</span>
    </div>;
};
export { ErrorMessage };